// @flow

import React from 'react'
import $ from 'jquery'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import bindAll from 'lodash/bindAll'
import { List, Map, fromJS } from 'immutable'
import { Field, FieldArray, reduxForm, formValueSelector, change } from 'redux-form'
import validate from './validate'
import RenderInput from '../partials/RenderInput'
import RenderInputEmail from '../partials/RenderInputEmail'
import RenderInputNumber from '../partials/RenderInputNumber'
import RenderSelect from '../partials/RenderSelect'
import RadioButton  from '../partials/RadioButton'
import 'select2'
import 'select2/dist/css/select2.min.css'

import {
    usersUpdateData,
    userGetDetail,
    getDropdownUserLevel,
    clearFormUser,
	removeMember,
	updateRole,
	updateProfile,
	addAstronautUser
} from '../../actions/users'

import { 
    getDropdownCompany,
    clearDropdownCompanyData,
    dropdownCompanyFetchData
} from '../../actions/companies'

require('es6-promise').polyfill()

type Props = {
	pathName: string,
	globalAddSweetAlertData: Function,
	globalHideSweetAlert: Function,
	globalActiveMenuHiringTeam: Function,
	globalActiveMenuTeamMember: Function,
	users: List<Map<string, any>>,
	user: Map<string, any>,
	userTemp: Map<string, any>,
	globalIndicatorData: Map<string, any>,
  	changeFieldValue: Function,
	industries: List<Map<string, any>>,
  	languages: List<Map<string, any>>,
	handleSubmit: Function,
	pristine: boolean,
	submitting: boolean,
	usersUpdateData: Function,
	userGetDetail: Function,
	usersSaveDataError:Map<string, any>,
	getDropdownUserLevel: Function,
	clearFormUser:Function,
	getDropdownCompany: Function,
	clearDropdownCompanyData: Function,
	dropdownCompanyFetchData: Function,
};

type State = {
	confirmAction: {
		show: boolean,
		type: string,
		index: number,
		newLevel: number,
		message: string
	},
	newCompanyInput: string,
	newCompanyId: number | null,
	newCompanyName: string,
	newCompanyLevel: number,
	isSelect2Initialized: boolean
};

class UserEdit extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
			confirmAction: {
				show: false,
				type: '',
				index: -1,
				newLevel: 0,
				message: ''
			},
			newCompanyInput: '',
			newCompanyId: null,
			newCompanyName: '',
			newCompanyLevel: 4,
			isSelect2Initialized: false
        }
        
        bindAll(this, [
			'handleSaveData',
			'renderCompanies',
			'renderCompanyRow',
			'handleAddCompanyFromForm',
			'handleRemoveCompany',
			'handleLevelChangeForCompany',
			'showConfirmation',
			'hideConfirmation',
			'confirmDelete',
			'confirmLevelChange',
			'initializeSelect2',
			'destroySelect2'
        ]);
    }

    componentDidMount() {
		const {
			userId,
			userGetDetail,
			getDropdownUserLevel,
			clearDropdownCompanyData,
			getDropdownCompany
		} = this.props
		
		Promise.all([
			getDropdownUserLevel(),
			clearDropdownCompanyData().then(() => getDropdownCompany(10, 0, ''))
		])
		.then(() => {
			if (userId) {
				return userGetDetail(userId);
			}
		})
		.then(() => {
			// Initialize Select2 after data is loaded
			this.initializeSelect2();
		})
		.catch(error => {
			console.error('Error loading user data:', error);
		});

		$('[data-toggle=tooltip]').tooltip()
	}

	componentDidUpdate(prevProps) {
		const { dropdownCompanies, formValues } = this.props;
		
		// Only reinitialize if dropdown companies have actually changed (reference comparison)
		// or if selected companies have changed
		const companiesChanged = prevProps.dropdownCompanies !== dropdownCompanies;
		const selectedCompaniesChanged = 
			JSON.stringify(prevProps.formValues?.companies) !== 
			JSON.stringify(formValues?.companies);
		
		if (companiesChanged || selectedCompaniesChanged) {
			// Use a small debounce to prevent rapid re-initialization
			if (this.select2UpdateTimeout) {
				clearTimeout(this.select2UpdateTimeout);
			}
			
			this.select2UpdateTimeout = setTimeout(() => {
				this.updateSelect2Options();
			}, 100);
		}
	}

	componentWillUnmount() {
		// Clear any pending timeouts
		if (this.select2UpdateTimeout) {
			clearTimeout(this.select2UpdateTimeout);
		}
		
		// Destroy Select2 instance
		this.destroySelect2();
	}

	destroySelect2() {
		const $select = $('#company-select');
		if ($select.length && $select.data('select2')) {
			$select.off('select2:select select2:clear');
			$select.select2('destroy');
			this.setState({ isSelect2Initialized: false });
		}
	}

	initializeSelect2() {
		const $select = $('#company-select');
		
		// Don't initialize if element doesn't exist yet
		if (!$select.length) {
			return;
		}

		// Destroy existing instance if any
		this.destroySelect2();

		const { formValues } = this.props;
		const isCareerCenter = formValues?.channel === "career_development_center";
		const placeholder = isCareerCenter ? 'Type or Select University' : 'Type or Select Company';

		// Initialize Select2 with minimal configuration
		$select.select2({
			placeholder: placeholder,
			allowClear: true,
			width: '100%',
			minimumResultsForSearch: 0, // Always show search box
			data: this.getFilteredCompanyOptions()
		});

		// Bind events once
		$select.on('select2:select', this.handleSelect2Select);
		$select.on('select2:clear', this.handleSelect2Clear);
		
		this.setState({ isSelect2Initialized: true });
	}

	// Separated method to get filtered options (reusable)
	getFilteredCompanyOptions() {
		const { formValues, dropdownCompanies } = this.props;
		
		// Get selected company IDs to exclude them from options
		const selectedCompanyIds = (formValues?.companies || [])
			.map(c => c.company_id)
			.filter(Boolean);

		return dropdownCompanies
			.filter(c => !selectedCompanyIds.includes(c.get('value')))
			.map(company => ({
				id: company.get('value'),
				text: company.get('label')
			}))
			.toArray();
	}

	// Update only the options without full reinitialization
	updateSelect2Options() {
		const $select = $('#company-select');
		
		if (!$select.length || !this.state.isSelect2Initialized) {
			return;
		}

		try {
			// Get current value before update
			const currentValue = $select.val();
			
			// Get filtered options
			const options = this.getFilteredCompanyOptions();
			
			// Clear and update options
			$select.empty().append('<option value=""></option>');
			
			options.forEach(opt => {
				const option = new Option(opt.text, opt.id);
				$select.append(option);
			});
			
			// Trigger change to update Select2
			$select.trigger('change');
			
			// Restore value if it still exists
			if (currentValue && options.find(opt => opt.id == currentValue)) {
				$select.val(currentValue).trigger('change');
			}
		} catch (error) {
			console.error('Error updating Select2 options:', error);
		}
	}

	// Event handlers as class methods for proper cleanup
	handleSelect2Select = (e) => {
		const data = e.params.data;
		this.setState({
			newCompanyId: data.id,
			newCompanyName: data.text
		});
	}

	handleSelect2Clear = () => {
		this.setState({
			newCompanyId: null,
			newCompanyName: ''
		});
	}

    handleSaveData(values) {
        const {
            updateProfile,
            userId			
        } = this.props

		// Transform companies array for API
		const formattedValues = {
			...values,
			companies: [] // update companies separately
		};

		// For CDC channel without companies array, fallback to old behavior
        if(!formattedValues.companies || formattedValues.companies.length === 0){
            if(values.channel === "career_development_center"){
                formattedValues.user_level = 4;
            }
        }

		updateProfile(userId, formattedValues)
    }

	handleAddCompany() {
		const { formValues, changeFieldValue } = this.props;
		const currentCompanies = formValues.companies || [];
		
		// Set default user_level to 4 for new companies
		changeFieldValue('companies', [
			...currentCompanies,
			{ 
				company_id: null, 
				company_name: '', 
				user_level: 4, 
				inputValue: '' 
			}
		]);
	}

	handleAddCompanyFromForm() {
		const { newCompanyId, newCompanyLevel, newCompanyName } = this.state;
		const { changeFieldValue, addAstronautUser, formValues, user } = this.props;
		const currentCompanies = formValues.companies || [];

		if (!newCompanyId) return;

		addAstronautUser(newCompanyId, this.props.userId, { 
			level: newCompanyLevel, 
			access_inc_jobs: 1, 
			access_existing_job: 1, 
			email: user.get('email'), 
			fulname: user.get('name') 
		})
		.then(() => {
			changeFieldValue('companies', [
				...currentCompanies,
				{ 
					company_id: newCompanyId, 
					company_name: newCompanyName, 
					user_level: newCompanyLevel, 
					inputValue: newCompanyName
				}
			]);

			// Reset form and Select2
			$('#company-select').val(null).trigger('change');
			this.setState({
				newCompanyInput: '',
				newCompanyId: null,
				newCompanyName: '',
				newCompanyLevel: 4
			});
		});
	}

	showConfirmation(type, index, message, newLevel = 0) {
		this.setState({
			confirmAction: {
				show: true,
				type,
				index,
				newLevel,
				message
			}
		});
	}

	hideConfirmation() {
		this.setState({
			confirmAction: {
				show: false,
				type: '',
				index: -1,
				newLevel: 0,
				message: ''
			}
		});
	}

	confirmDelete() {
		const { index } = this.state.confirmAction;
		const { formValues, changeFieldValue, removeMember, userId } = this.props;
		const currentCompanies = formValues.companies || [];
		const companyData = currentCompanies[index] || {};
		
		removeMember(companyData.company_id, userId).then(() => {
			changeFieldValue('companies', currentCompanies.filter((_, i) => i !== index));
		});

		this.hideConfirmation();
	}

	confirmLevelChange() {
		const { index, newLevel } = this.state.confirmAction;
		const { changeFieldValue, updateRole, userId } = this.props;
		const companyData = this.props.formValues.companies?.[index] || {};
		
		updateRole(companyData.company_id, userId, { 
			new_level: newLevel, 
			current_level: companyData.user_level, 
			delegate_id: '' 
		}).then(() => {
			changeFieldValue(`companies[${index}].user_level`, newLevel);
		});
		
		this.hideConfirmation();
	}

	handleRemoveCompany(index) {
		const { formValues } = this.props;
		const companyData = formValues.companies?.[index] || {};
		
		this.showConfirmation(
			'delete',
			index,
			`Are you sure you want to remove "${companyData.company_name || 'this company'}" from the user's companies?`
		);
	}

	handleLevelChangeForCompany(index, event) {
		const newLevel = parseInt(event.target.value);
		const { formValues } = this.props;
		const companyData = formValues.companies?.[index] || {};
		
		this.showConfirmation(
			'level',
			index,
			`Are you sure you want to change the user level for "${companyData.company_name}" to this new level?`,
			newLevel
		);
	}

	renderCompanyRow({ fields, meta: { error } }) {
		const { formValues, dropdownUserLevels, user } = this.props;

		const isCareerCenter = formValues.channel === "career_development_center";
		const label = isCareerCenter ? 'University' : 'Company';
		const showUserLevel = ['astrnt', 'popskul'].includes(formValues.channel);

		return (
			<div className="companies-container">
				{/* Section Label */}
				<div className="m-b-12">
					<label className="section-label">
						{isCareerCenter ? 'Universities' : 'Companies'} & User Levels
					</label>
				</div>

				{/* Add Company Form */}
				<div className="add-company-form m-b-16" style={{
					padding: '16px',
					backgroundColor: '#f8f9fa',
					borderRadius: '4px',
					border: '1px solid #dee2e6'
				}}>
					<div style={{ 
						display: 'grid', 
						gridTemplateColumns: showUserLevel ? '1fr 200px auto' : '1fr auto',
						gap: '12px',
						alignItems: 'end'
					}}>
						<div>
							<label style={{ display: 'block', marginBottom: '4px', fontSize: '13px', fontWeight: '500' }}>
								{label} Name
							</label>
							<select 
								id="company-select" 
								className="form-control"
								style={{
									width: '100%',
									height: '36px',
									padding: '6px 12px',
									fontSize: '14px',
									border: '1px solid #ced4da',
									borderRadius: '4px',
									backgroundColor: '#fff'
								}}
							>
								<option value=""></option>
							</select>
						</div>

						{showUserLevel && (
							<div>
								<label style={{ display: 'block', marginBottom: '4px', fontSize: '13px', fontWeight: '500' }}>
									User Level
								</label>
								<select
									onChange={(e) => this.setState({ newCompanyLevel: parseInt(e.target.value) })}
									style={{
										width: '100%',
										height: '36px',
										padding: '6px 12px',
										fontSize: '14px',
										border: '1px solid #ced4da',
										borderRadius: '4px',
										backgroundColor: '#fff'
									}}
								>
									{dropdownUserLevels
										.filter(f => (f.get('value') != 44 && f.get('value') != 1))
										.map(level => (
											<option key={level.get('value')} value={level.get('value')}
												selected={this.state.newCompanyLevel == level.get('value')}
											>
												{level.get('label')}
											</option>
										))
									}
								</select>
							</div>
						)}

						<button
							type="button"
							onClick={() => this.handleAddCompanyFromForm()}
							style={{
								padding: '8px 16px',
								height: '36px',
								background: this.state.newCompanyId ? '#28a745' : '#6c757d',
								color: 'white',
								border: 'none',
								borderRadius: '4px',
								fontSize: '14px',
								fontWeight: '500',
								transition: 'background 0.2s',
								whiteSpace: 'nowrap'
							}}
							onMouseEnter={(e) => {
								if (this.state.newCompanyId) e.target.style.background = '#218838';
							}}
							onMouseLeave={(e) => {
								if (this.state.newCompanyId) e.target.style.background = '#28a745';
							}}
						>
							<i className="fa fa-plus m-r-8"></i>
							Add
						</button>
					</div>
				</div>

				{fields.length === 0 && (
					<div className="m-b-12">
						<span className="error">At least one {label.toLowerCase()} is required</span>
					</div>
				)}

				{fields.length > 0 && (
					<>
						{/* Header Row */}
						<div className="company-header-row m-b-4" style={{ 
							display: 'grid', 
							gridTemplateColumns: showUserLevel ? '1fr 200px 40px' : '1fr 40px',
							gap: '12px',
							alignItems: 'center',
							paddingBottom: '6px',
							borderBottom: '1px solid #e0e0e0'
						}}>
							<div style={{ fontWeight: '600', fontSize: '13px', color: '#666' }}>
								{label}
							</div>
							{showUserLevel && (
								<div style={{ fontWeight: '600', fontSize: '13px', color: '#666' }}>
									User Level
								</div>
							)}
							<div></div>
						</div>

						{fields.map((company, index) => {
							const companyData = formValues.companies?.[index] || {};

							// Check if this company has Account Holder level (44)
							const currentCompany = user.get('companies')?.find(c => c.get('id') === companyData.company_id);
							const isAccountHolder = currentCompany?.get('user_level') === 44;

							// Get user level options, filter out Account Holder for new selections
							const levelOptions = isAccountHolder 
								? dropdownUserLevels.filter(f => f.get('value') != 1) 
								: dropdownUserLevels.filter(f => f.get('value') != 44 && f.get('value') != 1);

							return (
								<div key={index} className="company-row-container m-b-8">
									{/* Main Row with Grid Layout */}
									<div 
										className="company-row" 
										style={{ 
											display: 'grid', 
											gridTemplateColumns: showUserLevel ? '1fr 200px 40px' : '1fr 40px',
											gap: '12px',
											alignItems: 'center',
											minHeight: '36px'
										}}
									>
										{/* Company Name Display */}
										<div className="company-input-group">
											<input
												type="text"
												value={companyData.company_name || ''}
												readOnly
												disabled
												style={{
													width: '100%',
													height: '36px',
													padding: '6px 12px',
													fontSize: '14px',
													border: '1px solid #ced4da',
													borderRadius: '4px',
													backgroundColor: '#e9ecef',
													cursor: 'default',
													color: '#495057'
												}}
											/>
											<Field name={`${company}.company_id`} component="input" type="hidden" />
										</div>

										{/* User Level Select */}
										{showUserLevel && (
											<div className="level-select-group">
												{isAccountHolder ? (
													<input
														type="text"
														value="Account Holder"
														readOnly
														disabled
														style={{
															width: '100%',
															height: '36px',
															padding: '6px 12px',
															fontSize: '14px',
															border: '1px solid #ced4da',
															borderRadius: '4px',
															backgroundColor: '#e9ecef',
															cursor: 'not-allowed',
															color: '#495057'
														}}
													/>
												) : (
													<Field
														name={`${company}.user_level`}
														component={RenderSelect}
														placeholder="User Level"
														dropdownOption={levelOptions}
														onChange={(e) => this.handleLevelChangeForCompany(index, e)}
													/>
												)}
											</div>
										)}

										{/* Remove Button */}
										<button
											type="button"
											className="remove-button"
											onClick={() => this.handleRemoveCompany(index)}
											disabled={fields.length === 1 || isAccountHolder}
											style={{
												background: 'transparent',
												border: 'none',
												color: '#dc3545',
												cursor: (fields.length === 1 || isAccountHolder) ? 'not-allowed' : 'pointer',
												fontSize: '16px',
												padding: '4px 8px',
												opacity: (fields.length === 1 || isAccountHolder) ? 0.5 : 1,
												transition: 'all 0.2s',
												height: '36px',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center'
											}}
											onMouseEnter={(e) => {
												if (fields.length > 1 && !isAccountHolder) e.target.style.color = '#bd2130';
											}}
											onMouseLeave={(e) => {
												e.target.style.color = '#dc3545';
											}}
										>
											<i className="fa fa-times"></i>
										</button>
									</div>
								</div>
							);
						})}
					</>
				)}

				{error && <div className="error m-t-8">{error}</div>}
			</div>
		);
	}

	renderCompanies(props) {
		return this.renderCompanyRow(props);
	}
    
    renderError({ meta: { touched, error } }) {
        return touched && error ? <div><span className="error">{error}</span></div> : false
    }

    render() {
		const {
			user,
			globalIndicatorData,
			handleSubmit,
			pristine,
			submitting,
			userPrivilege,
		} = this.props
		
		const { confirmAction } = this.state;
		const isIndicatorClass = globalIndicatorData.get('isShow') ? 'p-t-56' : ''

		return (
			<div className={isIndicatorClass}>
				{/* Confirmation Modal */}
				{confirmAction.show && (
					<div 
						className="modal-overlay" 
						style={{
							position: 'fixed',
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							backgroundColor: 'rgba(0, 0, 0, 0.5)',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							zIndex: 1050
						}}
					>
						<div 
							className="modal-content"
							style={{
								backgroundColor: 'white',
								borderRadius: '8px',
								padding: '24px',
								maxWidth: '500px',
								width: '90%',
								boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
							}}
						>
							<h4 style={{ marginTop: 0, marginBottom: '16px' }}>Confirm Action</h4>
							<p style={{ marginBottom: '24px', color: '#666' }}>{confirmAction.message}</p>
							<div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
								<button
									type="button"
									onClick={this.hideConfirmation}
									style={{
										padding: '8px 16px',
										background: '#6c757d',
										color: 'white',
										border: 'none',
										borderRadius: '4px',
										cursor: 'pointer',
										fontSize: '14px'
									}}
								>
									Cancel
								</button>
								<button
									type="button"
									onClick={confirmAction.type === 'delete' ? this.confirmDelete : this.confirmLevelChange}
									style={{
										padding: '8px 16px',
										background: '#dc3545',
										color: 'white',
										border: 'none',
										borderRadius: '4px',
										cursor: 'pointer',
										fontSize: '14px'
									}}
								>
									Confirm
								</button>
							</div>
						</div>
					</div>
				)}

				<div className="div-support-container">
					<section className="wrapper">
						<div className="main-content">
							<div className="container-fluid">
								<div className="big-panel">
									<div className="flex-container flex-between">
										<h5 className="title-heading">Edit User</h5>
									</div>

									<div className="div-support-create-user-container">
										<div>
											<Link to={{pathname: '/support/users', state: {prevPage: 'user-detail'}}} className="back-button">
												<i className="fa fa-angle-left"></i>Back
											</Link>
										</div>
										<hr />
										<form onSubmit={handleSubmit(this.handleSaveData)} id="UserEdit" encType="multipart/form-data">
											<div>
												<div>
													<label>Channel</label>
												</div>
												<Field
													component={RadioButton}
													type="radio"
													value="astrnt"
													name="channel"
													className={`channel as-radio m-r-15 ${user.get('channel') === "astrnt" ? "is-on" : "hide"}`}
													disabled={true}
												>
													Astrnt.co
												</Field>
												<Field
													component={RadioButton}
													type="radio"
													value="popskul"
													name="channel"
													className={`channel as-radio m-r-15 ${user.get('channel') === "popskul" ? "is-on" : "hide"}`}
													disabled={true}
												>
													awalkarir.id
												</Field>
												<Field
													component={RadioButton}
													type="radio"
													value="career_development_center"
													name="channel"
													className={`channel as-radio m-r-15 ${user.get('channel') === "career_development_center" ? "is-on" : "hide"}`}
													disabled={true}
												>
													Career Development Center
												</Field>
												<Field name="channel" component={this.renderError}/>
											</div>
											<div>
												<Field
													name="name"
													type="text"
													component={RenderInput}
													label="Full Name"
													placeholder="Full Name"
													id="name"
												/>
											</div>
											<div>
												<Field
													name="preferred_name"
													type="text"
													component={RenderInput}
													label="Preferred Name"
													placeholder="Preferred Name"
													id="preferred_name"
												/>
											</div>
											<div>
												<Field
													name="email"
													type="email"
													component={RenderInputEmail}
													label="Email"
													placeholder="Email"
													id="email"
													disabled={true}
												/>
											</div>
											<div>
												<Field
													name="mobile_number"
													type="text"
													component={RenderInputNumber}
													label="Mobile Number"
													placeholder="Mobile Number"
													id="mobile_number"
												/>
											</div>

											{/* Submit Button - Moved before companies table */}
											<div className="center m-t-24 m-b-24">
												{userPrivilege.includes('UPDATE_USER') && (
													<button 
														disabled={pristine || submitting} 
														className="submit-button"
														type="submit"
													>
														Update User
													</button>
												)}
											</div>

											{/* Multi-company section */}
											<div className="m-t-24 m-b-24">
												<FieldArray 
													name="companies" 
													component={this.renderCompanies}
												/>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
		)
	}
}

UserEdit = reduxForm({
  form: 'UserEdit',
  validate: validate,
  initialValues: {
    name: '',
    email:'',
    mobile_number: "",
    companies: [],
    channel:'',
    preferred_name:''
  },
  enableReinitialize: true
})(UserEdit)

const selector = formValueSelector('UserEdit')

const mapStateToProps = (state, ownProps) => {
    const user = state.user
	
	// Transform user.companies array to form format
	const companiesArray = user.get('companies') 
		? user.get('companies').toJS().map(company => ({
			company_id: company.id,
			company_name: company.title,
			user_level: company.user_level,
			inputValue: company.title
		}))
		: [];

    const initialValues = {
        name: user.get('name') || '',
        email: user.get('email') || '',
        mobile_number: user.get('mobile_number') || '',
        companies: companiesArray,
        channel: user.get('channel') || '',
        preferred_name: user.get('preferred_name') || ''
    }
	
    return {
        formValues: selector(
            state,
            'name',
            'email',
            'mobile_number',
            'companies',
            'channel',
            'preferred_name'
        ),
        initialValues,
        pathName: ownProps.location.pathname,
        globalIndicatorData: state.globalIndicatorData,
        user: state.user,
        users: state.users,
        userTemp: state.userTemp,
        usersSaveDataError: state.usersSaveDataError,
        userId: ownProps.match.params.userId,
        dropdownUserLevels: state.dropdownUserLevels,
        userPrivilege: state.userPrivilege,
        dropdownCompanies: state.dropdownCompanies
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        usersUpdateData: (userId,userData) => dispatch(usersUpdateData(userId,userData)),
        updateProfile: (userId,userData) => dispatch(updateProfile(userId,userData)),
        userGetDetail: (userId) => dispatch(userGetDetail(userId)),
        getDropdownUserLevel: () => dispatch(getDropdownUserLevel()),
        clearFormUser: () => dispatch(clearFormUser()),
        getDropdownCompany: (limit, offset, channel) => dispatch(getDropdownCompany(limit, offset, channel)),
        dropdownCompanyFetchData: (companies) => dispatch(dropdownCompanyFetchData(companies)),
        clearDropdownCompanyData: () => dispatch(clearDropdownCompanyData()),
        changeFieldValue: (field, value) => dispatch(change('UserEdit', field, value, true, true)),
		removeMember: (companyId, userId) => dispatch(removeMember(companyId, userId)),
		updateRole: (companyId, userId, data) => dispatch(updateRole(companyId, userId, data)),
		addAstronautUser: (companyId, userId, data) => dispatch(addAstronautUser(companyId, userId, data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserEdit)